import { Component, OnInit } from '@angular/core';

enum MessageType {
    Error, Warning, Success
}

class Message {
    public type: MessageType;
    public messages: string[];
    public closed: boolean;
}

@Component({
    selector: 'messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

    public static instance: MessagesComponent = new MessagesComponent();
    public messages: Message[] = [];
    public messageType = MessageType;

    ngOnInit(): void {
        MessagesComponent.instance = this;
    }

    public showError(messages: string[]) {
        this.showMessage(MessageType.Error, messages);
    }
    
    public showErrorCustomisedTime(messages: string[], timeForClose: number) {
        this.showMessageCustomisedTime(MessageType.Error, messages, timeForClose);
    }
    
    public showWarning(messages: string[]) {
        this.showMessage(MessageType.Warning, messages);
    }
    
    public showSuccess(messages: string[]) {
        this.showMessage(MessageType.Success, messages);
    }
    
    private showMessage(type: MessageType, messages: string[]) {
        let message: Message = new Message();

        message.type = type;
        message.messages = messages;
        message.closed = false;

        this.messages.push(message);

        setTimeout(() => { this.close(message) }, 3000);        
    }

    private showMessageCustomisedTime(type: MessageType, messages: string[], timeForClose: number) {
        let message: Message = new Message();

        message.type = type;
        message.messages = messages;
        message.closed = false;

        this.messages.push(message);

        setTimeout(() => { this.close(message) }, timeForClose);        
    }

    public close(message: Message) {
        message.closed = true;
        setTimeout(() => {
            let index = this.messages.indexOf(message);
            if (index >= 0) {
                this.messages.splice(index, 1);
            }         
        }, 250);
    }


}